import * as actionTypes from '../actions/actionTypes';

const initialState = {
    cities: null,
    cityOptions: null,
    countryOptions: null,
    storages: null,
    error: false,
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_CITY:

            const cityOptions = action.cities.map(city=>{
                return {value: city.id, label: city.name, country: city.country}
            })

            const countries = [...action.cities].sort((a,b)=>{
                if (a.country < b.country) return -1
                if (a.country > b.country) return 1
                    return 0
                }).map(city=>{
                return city.country
            })

            const countriesUnic = [...new Set(countries)]

            const countryOptions = countriesUnic.map(item=>{
                return {value: item, label: item}
            })
            
            return {
                ...state,
                cities: action.cities,
                cityOptions: cityOptions,
                countryOptions: countryOptions,
                error: false,
                loading: false
            };
        case actionTypes.SET_STORAGES:
            return {
                ...state,
                storages: action.storages.storageBlock,
                error: false,
                loading: false
            };
        case actionTypes.FETCH_CITY_STARTING:
        case actionTypes.FETCH_STORAGES_STARTING:
            return {
                ...state,
                error: false,
                loading: true
            };
        case actionTypes.FETCH_CITY_FAILED:
        case actionTypes.FETCH_STORAGES_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
};

export default reducer;